import { PayloadAction, createSelector, createSlice } from '@reduxjs/toolkit'
import { omit } from 'lodash'

// eslint-disable-next-line import/no-cycle
import { RootState } from './types'

const initialState: Record<string, any> = {}

const slice = createSlice({
  name: 'persisted',
  initialState,
  reducers: {
    remove(state, action: PayloadAction<string>) {
      state = omit(state, action.payload)
    },
    set(state, action: PayloadAction<{ id: string; data: any }>) {
      const { id, data } = action.payload
      state[id] = data
    },
  },
})

// Actions
export const { set: setPersisted, remove: removePersisted } = slice.actions

// Selectors
const selectPersisted = (state: RootState) => state.persisted

export const makeSelectPersisted = <T>(id: string, fallback: T) =>
  createSelector(selectPersisted, (saved) => {
    return saved[id] ?? fallback
  })

// Reduce
export default slice.reducer
